import { render, staticRenderFns } from "./MCard.vue?vue&type=template&id=6779aaa4&"
import script from "./MCard.vue?vue&type=script&lang=js&"
export * from "./MCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports